export default __webpack_public_path__ + "static/media/ok_button.9c5e5c63.png";